import React from "react";

import { DISPENSARY_PAGES } from "@/constants/dispensary";
import { Dispensary } from "@/custom-types/Dispensary";

import Button from "@/components/botanic/Button";
import MetaTags from "@/components/MetaTags";

import DispensaryHeader from "../DispensaryHeader";
import DispensaryTabs from "../DispensaryTabs";

const MenuItem404Page: React.FC<{ dispensary: Dispensary }> = ({
  dispensary,
}) => (
  <>
    <MetaTags
      title={`${dispensary.name} - Menu Item Not Found`}
      robots={"noindex"}
    />
    <DispensaryHeader dispensary={dispensary} />
    <section>
      <DispensaryTabs
        activeTab={DISPENSARY_PAGES.menu}
        dispensary={dispensary}
      />
      <div className="container bg-white py-xl">
        <h1>Currently out of stock</h1>
        <div className="my-lg mx-sm">
          This item is unavailable for pickup or delivery orders right now.
        </div>
        <Button
          className="mr-sm my-md px-xl py-sm"
          href={`/dispensary-info/${dispensary.slug}/menu`}
          variant="secondary"
        >
          shop dispensary menu
        </Button>
      </div>
    </section>
  </>
);

export default MenuItem404Page;
